/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AgendaCommercialeDashboardInputDto interface.
 */
export function instanceOfAgendaCommercialeDashboardInputDto(value) {
    return true;
}
export function AgendaCommercialeDashboardInputDtoFromJSON(json) {
    return AgendaCommercialeDashboardInputDtoFromJSONTyped(json, false);
}
export function AgendaCommercialeDashboardInputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'idStrutturaBusiness': json['idStrutturaBusiness'] == null ? undefined : json['idStrutturaBusiness'],
        'periodoDa': json['periodoDa'] == null ? undefined : (new Date(json['periodoDa'])),
        'periodoA': json['periodoA'] == null ? undefined : (new Date(json['periodoA'])),
        'limit': json['limit'] == null ? undefined : json['limit'],
    };
}
export function AgendaCommercialeDashboardInputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'idStrutturaBusiness': value['idStrutturaBusiness'],
        'periodoDa': value['periodoDa'] == null ? undefined : ((value['periodoDa']).toISOString().substring(0, 10)),
        'periodoA': value['periodoA'] == null ? undefined : ((value['periodoA']).toISOString().substring(0, 10)),
        'limit': value['limit'],
    };
}
